
import type {
  ProductDomainService,
  QueryRankingElementRankingDTO,
} from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import type { ToolsMessages } from '../../models'
import { defineComponent } from 'vue'
import { CONTAINER } from '../../config'
import { TYPES } from '../../config/inversify.types'
import { UiTooltip } from '../keen-ui'
import RankingElementsList from './ranking-elements-list.component.vue'

export default defineComponent({
  name: 'ProductsRankingList',
  components: {
    RankingElementsList,
    UiTooltip,
  },
  props: {
    rankingElements: {
      type: Array as PropType<Array<QueryRankingElementRankingDTO>>,
      required: true,
    },
    messages: {
      type: Object as PropType<ToolsMessages['configurations']>,
      required: true,
    },
    readOnly: Boolean,
  },
  setup() {
    function isElementValueValid(element: QueryRankingElementRankingDTO): boolean {
      return CONTAINER.get<ProductDomainService>(TYPES.ProductDomainService).isProductIdValid(
        element.fieldValue,
      )
    }

    return {
      baseClass: 'epb-products-ranking',
      isElementValueValid,
    }
  },
})
